import baseRequest from "../_core/baseRequest";
const namingRules = {};

export default {
    getCurrentStatistics: params =>
        baseRequest.get(`/stats/current` + baseRequest.queryString(params, namingRules)),
    getHistoricStatistics: params =>
        baseRequest.get(`/stats/historic` + baseRequest.queryString(params, namingRules)),
    getQueueStatistics: params =>
        baseRequest.get(`/stats/historic/queue` + baseRequest.queryString(params, namingRules)),
    getMergedOrderStatistics: params =>
        baseRequest.get(`/stats/historic/merge` + baseRequest.queryString(params, namingRules)),
    getDurationStatistics: params =>
        baseRequest.get(`/stats/duration` + baseRequest.queryString(params, namingRules)),
    getCourierDeliveryStatistics: params =>
        baseRequest.get(
            `/courierdeliverystats/stats` + baseRequest.queryString(params, namingRules)),
    getCompanyOrderStatistics: params =>
        baseRequest.get("/companyOrderStats/stats" + baseRequest.queryString(params, namingRules)),
    getCompanyOrderHourlyStatistics: params =>
        baseRequest.get(
            "/companyOrderStats/hourlystats" + baseRequest.queryString(params, namingRules)
        ),
    getCompanyOrderDurationStatistics: params =>
        baseRequest.get(
            "/companyOrderStats/duration" + baseRequest.queryString(params, namingRules)
        ),
    getCourierDeliveryStatistics: params =>
        baseRequest.get(
            `/courierdeliverystats/stats` + baseRequest.queryString(params, namingRules)
        )
};
